"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get IntegrationWorker () {
        return IntegrationWorker;
    },
    get IntegrationWorkerConnectionStatus () {
        return IntegrationWorkerConnectionStatus;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const IntegrationWorkerConnectionStatus = _zod.z.enum([
    "pending",
    "connected",
    "not-connected"
]);
const IntegrationWorker = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    integration: _zod.z.instanceof(_bson.ObjectId),
    external_id: _zod.z.string(),
    external_company_id: _zod.z.string(),
    last_updated: _zod.z.date(),
    created_at: _zod.z.date(),
    status: IntegrationWorkerConnectionStatus,
    data: _zod.z.record(_zod.z.string(), _zod.z.unknown()),
    performyard_user_id: _zod.z.instanceof(_bson.ObjectId).nullish()
});
